<template>
    <div class="alert">
        <b-alert
            v-model="showTop"
            class="position-fixed fixed-top m-0 rounded-0 text-center"
            style="z-index: 2000;"
            :variant="alert.variant"
            dismissible
            @dismissed="closed"
        >
            {{alert.alert}}
        </b-alert>
    </div>
</template>

<script>
import Vue from 'vue'

    export default Vue.extend({
        name: 'Alert',
        props: {
            alert: { type: Object, default: () => ({}) },
        },
        data() {
            return {
                showTop: false
            }
        },
        methods: {
            closed () {
                this.$emit('closed')
            }
        },
        mounted () {
            this.showTop = true
        },
    })
</script>

<style src="./Alert.scss" lang="scss" scoped />